import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import { loadRuntimeConfig } from "./lib/api.js";
import "./styles.css";

/**
 * Boot order matters: the runtime config is fetched BEFORE React renders — the same
 * reasoning as the merchant app. A portal that renders and cannot reach its API is worse
 * than one that admits it could not read its configuration.
 */
const root = document.getElementById("root");
if (root === null) throw new Error("#root is missing from index.html");

loadRuntimeConfig()
  .then((config) => {
    createRoot(root).render(
      <StrictMode>
        <App config={config} />
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    root.innerHTML =
      '<div class="boot-error"><h1>Ecomally Admin could not start</h1>' +
      "<p>The portal could not read its configuration. This is a deployment problem, not something you can fix by retrying.</p></div>";
    void error;
  });
